import { useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import {
  selectIsAuthenticated,
  selectAuthStatus,
  selectAuthError,
  login,
} from '../../entities/auth/model';
import { loginSchema } from '@shared/lib/validators/registration-schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, FieldValues } from 'react-hook-form';
import { LoadingWrapper } from '../../shared/ui/loading-wrapper';
import { InputField } from '../../shared/ui/input-field';
import { Button } from '../../shared/ui/button';
import AuthLayout from '@shared/ui/access-layout';
import { loadRememberMeData } from '@entities/auth/lib';
import { useAppDispatch, useAppSelector } from '../../app/store/store';

const Login = () => {
  const dispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(loginSchema),
    shouldUnregister: false,
    defaultValues: {
      password: '',
      username: '',
      rememberMe: false,
    },
  });

  const userStorage = loadRememberMeData();

  const authStatus = useAppSelector(selectAuthStatus);
  const isAuth = useAppSelector(selectIsAuthenticated);
  const error = useAppSelector(selectAuthError);

  useEffect(() => {
    document.title = 'Вход';
  }, []);

  function onSubmit(data: FieldValues) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(login(data as any));
  }

  return (
    <LoadingWrapper status={authStatus}>
      <AuthLayout
        leftContent={
          <section className="flex justify-center items-center flex-col absolute top-[45%] left-[25%] -translate-x-1/2 -translate-y-[20%] text-center w-[346px]">
            <h2 className="text-[28px] text-white">Добро пожаловать!</h2>
            <div className="my-[34px] mx-auto w-[113px] border border-white"></div>
            <div className="font-medium text-[22px] mt-[34px] leading-[140%] text-white">
              Заполните регистрационные данные, чтобы перейти в личный кабинет
            </div>
          </section>
        }
      >
        <form onSubmit={handleSubmit(onSubmit)} className="w-[70%] relative">
          <h2 className="font-bold text-[28px] text-[#141414]">Вход</h2>
          <div className="mt-[45px] text-[#b4b4b4] text-base leading-[140%]">
            Пожалуйста, введите информацию в поля ниже, чтобы войти в личный
            кабинет
          </div>

          <div className="mt-[30px]">
            <InputField
              name="username"
              inputName="username"
              id="username"
              label="Email или Логин"
              placeholder="Введите Email или Логин"
              register={register}
              errors={errors}
            />
          </div>
          <div className="mt-[30px]">
            <InputField
              name="password"
              inputName="password"
              type="password"
              placeholder="Введите пароль"
              id="password"
              label="Пароль"
              register={register}
              errors={errors}
            />
          </div>
          <div className="mt-[30px] mb-[30px] flex justify-between">
            <label className="flex items-center">
              <input
                className="bg-[#9e9e9e] accent-[#e3282a] h-5 w-5 align-sub"
                type="checkbox"
                value="false"
                {...register('rememberMe')}
              />
              <span className="ml-[10px]">Запомнить меня</span>
            </label>

            <Link
              to={'/password_reset/reset'}
              style={{ cursor: 'pointer', color: 'blue' }}
              className="text-base font-medium"
            >
              Забыли пароль?
            </Link>
          </div>
          {error && (
            <p
              style={{
                color: '#E3282A',
                fontSize: '14px',
                marginTop: '10px',
              }}
            >
              {error}
            </p>
          )}
          {userStorage && isAuth && <Navigate to="/" replace={true} />}
          <div className="flex justify-between gap-2">
            <Button type="submit">Войти</Button>
            <Link to={'/register'}>
              <Button type="button">Зарегистрироваться</Button>
            </Link>
          </div>
        </form>
      </AuthLayout>
    </LoadingWrapper>
  );
};

export default Login;
